import React from "react";
import "./AdapidStatsCard.css";

/**
 * Modern Vanilla CSS StatsCard (Flex/Grid Align Style)
 */
const AdapIdStatsCard = ({
  title,
  value,
  // The left element can be a standard icon component or a Recharts SVG wrapper
  leftElement,
  // Pass object with color variables: { bg: "rgb(236, 253, 245)", text: "rgb(16, 185, 129)" }
  themeColors,
  subLabel,
  loading = false,
  onClick,
  className = "",
}) => {
  const formatValue = (val) => {
    if (val === null || val === undefined) return "—";
    if (typeof val === "number") return val.toLocaleString();
    return val;
  };

  // Dynamically set CSS variables if custom theme colors are passed
  const styleVariables = themeColors
    ? {
        "--card-icon-bg": themeColors.bg,
        "--card-icon-color": themeColors.text,
      }
    : {};

  return (
    <div
      className={`v-stats-card ${onClick ? "v-clickable" : ""} ${className}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      style={styleVariables}
    >
      {loading ? (
        <div className="v-stats-loading-wrapper">
          <div className="v-skeleton v-skeleton-square" />
          <div className="v-stats-loading-text">
            <div className="v-skeleton v-skeleton-line-md" />
            <div className="v-skeleton v-skeleton-line-sm" />
          </div>
        </div>
      ) : (
        <>
          {leftElement && (
            <div className={`v-stats-left-container ${themeColors ? "v-has-theme" : ""}`}>
              {leftElement}
            </div>
          )}

          <div className="v-stats-info-block">
            <p className="v-stats-value">{formatValue(value)}</p>
            <p className="v-stats-title">{title}</p>
            {subLabel && <p className="v-stats-sublabel">{subLabel}</p>}
          </div>
        </>
      )}
    </div>
  );
};

export default AdapIdStatsCard;